import { createContext } from 'react'

import { LetterRequestsForCustomerQuery } from '@app/queries/LetterRequestsForCustomer/LetterRequestsForCustomer.queries'

export type LetterRequestContextType = {
  letterRequestData?: LetterRequestsForCustomerQuery['letterRequestsForCustomer']
  letterLoading: boolean
  refetchLetter?: () => Promise<any>
}

const initialValue = {
  letterRequestData: {
    letterDocumentIds: [],
    letterAllowance: undefined,
    openLetterRequest: undefined
  },
  letterLoading: false
}

export const letterRequestContext = createContext<LetterRequestContextType>(initialValue)
